import React from "react";
import PropTypes from "prop-types";

class Header extends React.Component {
  render() {
    const slim = this.props.slim ? "slim" : "";
    const margin = this.props.margin ? `margin-${this.props.margin}` : "";
    const big = this.props.big ? "big" : "";
    const light = this.props.light ? "light" : "";
    const className = this.props.className ? this.props.className : "";

    const cssClasses = `${slim} ${margin} ${big} ${light} ${className}`;

    return React.createElement(
      `h${this.props.size}`,
      { className: cssClasses },
      this.props.children
    );
  }
}

Header.defaultProps = {
  size: 4,
  margin: null,
  slim: false,
  big: false,
  light: false,
  className: false,
  children: null
};

Header.propTypes = {
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  margin: PropTypes.oneOf(["no", "no-top", "no-bottom"]),
  slim: PropTypes.bool,
  big: PropTypes.bool,
  light: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node
};

export default Header;
